import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import AuthService from "../services/auth.service";
import { useAuth } from "../contexts/AuthContext";
import tokenMonitor from "services/tokenMonitor";
import SITE from "../services/siteConfig";
import logo from "../assets/img/logo-wide.png";
import styles from "./Login.module.css";

const required = (value) => {
  if (!value) {
    return <div className={styles.fieldError}>This field is required</div>;
  }
};

const HomeLogin = () => {
  const { login } = useAuth();
  const [emailSignIn, setEmailSignIn] = useState("");
  const [passwordSignIn, setPasswordSignIn] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  let navigate = useNavigate();
  const formSignIn = useRef();
  const checkBtn = useRef();

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);
    formSignIn.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      try {
        const user = await login({
          emailSignIn: emailSignIn,
          passwordSignIn: passwordSignIn,
        });
        tokenMonitor.restart();
        if (user.roles && user.roles.includes("ROLE_ADMIN")) {
          navigate("/admin/users");
        } else {
          navigate("/user/dashboard");
        }
      } catch (error) {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setLoading(false);
        setMessage(resMessage);
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      {/* Left Panel — Branding */}
      <div className={styles.brand}>
        <div className={styles.brandOverlay} />
        <div className={styles.brandContent}>
          {/* <img src={logo} alt={SITE.name} className={styles.brandLogo} /> */}
          <h1 className={styles.brandTitle}>{SITE.name}</h1>
          <p className={styles.brandSub}>
            Secure financial management for massage
            <br />
            and bodywork professionals
          </p>
          <div className={styles.brandFeatures}>
            <div className={styles.featureItem}>
              <span className={styles.featureDot} />
              Real-time balance tracking
            </div>
            <div className={styles.featureItem}>
              <span className={styles.featureDot} />
              Secure transactions & escrow
            </div>
            <div className={styles.featureItem}>
              <span className={styles.featureDot} />
              Professional certification management
            </div>
          </div>
        </div>
      </div>

      {/* Right Panel — Form */}
      <div className={styles.formPanel}>
        <div className={styles.formCard}>
          <img src={logo} alt={SITE.name} className={styles.formLogo} />
          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>Welcome back</h2>
            <p className={styles.formSub}>
              Sign in to your account to continue
            </p>
          </div>

          <Form
            onSubmit={handleLogin}
            ref={formSignIn}
            className={styles.form}
          >
            {/* Email */}
            <div className={styles.field}>
              <label className={styles.label}>Email Address</label>
              <div className={styles.inputWrapper} style={{ width: "100%" }}>
                <span className={styles.inputIcon}>📧</span>
                <Input
                  type="text"
                  className={styles.input}
                  name="email"
                  placeholder="Enter your email"
                  value={emailSignIn}
                  onChange={(e) => setEmailSignIn(e.target.value)}
                  validations={[required]}
                />
              </div>
            </div>

            {/* Password */}
            <div className={styles.field}>
              <label className={styles.label}>Password</label>
              <div className={styles.inputWrapper}>
                <span className={styles.inputIcon}>🔒</span>
                <Input
                  type={showPassword ? "text" : "password"}
                  className={styles.input}
                  name="password"
                  placeholder="Enter your password"
                  value={passwordSignIn}
                  onChange={(e) => setPasswordSignIn(e.target.value)}
                  validations={[required]}
                />
                <button
                  type="button"
                  className={styles.passToggle}
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            {/* Forgot password */}
            <div className={styles.forgotRow}>
              <span className={styles.forgotLink}>Forgot password?</span>
            </div>

            {/* Submit */}
            <button className={styles.submitBtn} disabled={loading}>
              {loading ? (
                <span className={styles.spinner} />
              ) : (
                "Sign In"
              )}
            </button>

            {/* Error message */}
            {message && (
              <div className={styles.errorBox} role="alert">
                {message}
              </div>
            )}

            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Form>
        </div>
      </div>
    </div>
  );
};

export default HomeLogin;